import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import {
	XThemeForm,
	XSwitch,
	XThemeContainer,
	XThemeDetailsCards,
	XThemeInputText,
	XThemeRadio,
	XThemeSwitchBtn,
	XThemeButton,
	XThemeTable,
	XThemeTag,
	XTag,
} from '../../../../styles/GlobalThemeStyle';
import {
	Row,
	Col,
	Button,
	Input,
	notification,
	Flex,
	Space,
	Table,
	Form,
} from 'antd';
import {
	XThemeTilesCard,
	XThemeVoiceAssCard,
	XThemeVoiceaAsistCard,
	XThemeVoiceAssSeeBtn,
	XThemeVoiceAssTable,
	XThemeVoiceAssTableCard,
	XThemeVoiceAssTitle,
	XThemeVoiceCreateCaseBtn,
	XThemeVoiceaAsistChartCard,
	XThemeVoiceaAssSearchBar,
	XThemeFitToScreen,
	XThemeFixBottom,
	XThemeVoiceaAsistChatCard,
	XThemeVACheckbox,
	XThemeVASubmitBTN,
	XVSLottie,
	XVSLottieWrapper,
	XThemeVSCollapse,
	XThemeVSDetailsCard,
	XThemeHeaderBTN,
	XThemeVSDetailsFooter,
	XThemeVoiceAssCard2,
	XThemeVoiceAssContainer,
	XThemeVSSetViewPort,
	XThemeVSScrollContainer,
	XThemeVSSumInnerCard,
	XThemeVSSumListCard,
} from '../../VoiceAssistanceStyle';
import {
	CalendarOutlined,
	CaretRightOutlined,
	PlusCircleOutlined,
	RightOutlined,
	PlusSquareOutlined,
} from '@ant-design/icons';
import VSLoaderJson from '../../../../json/loader.json';
import VSdotsAnimation from '../../../../json/dotsAnimation.json';

const items = [
	{
		key: '1',
		label: 'Clinical Summary',
		children: (
			<XThemeVSSumInnerCard>
				<Row>
					<Col xs={24} className="text-end headerBorder">
						<Space>
							<XThemeVASubmitBTN
								size="medium"
								className="radiusBtn"
								shape="square"
								icon={
									<img src="/images/edit-icon.svg" alt="" />
								}
							/>
							<XThemeVASubmitBTN
								size="medium"
								className="radiusBtn"
								shape="square"
								icon={<PlusSquareOutlined />}
							/>
						</Space>
					</Col>
				</Row>
				<Row gutter={[15, 15]}>
					<Col xs={24}>
						<p className="cardPara">
							78F w/ bilateral cataracts but without any
							significant visual impairment is recommended to have
							cataract extraction surgery
						</p>
					</Col>
				</Row>
			</XThemeVSSumInnerCard>
		),
	},
	{
		key: '2',
		label: 'Present Complaint',
		children: (
			<>
				<XThemeVSSumInnerCard>
					<Row className="mb-3">
						<Col xs={24} className="text-end">
							<Space>
								<XThemeVASubmitBTN
									size="medium"
									className="radiusBtn"
									shape="square"
									icon={
										<img
											src="/images/edit-icon.svg"
											alt=""
										/>
									}
								/>
								<XThemeVASubmitBTN
									size="medium"
									className="radiusBtn"
									shape="square"
									icon={<PlusSquareOutlined />}
								/>
							</Space>
						</Col>
					</Row>

					<XThemeVSSumListCard className="mb-3">
						<Row gutter={[15, 15]} className="align-items-center">
							<Col xs={24} lg={14}>
								<div className="para1">
									Congestive <span>heart failure</span>
								</div>
							</Col>
							<Col
								xs={24}
								lg={6}
								className="text-center"
								role="button"
								style={{
									borderLeft: '1px solid #57636F26',
									borderRight: '1px solid #57636F26',
								}}
							>
								<div className="para2">ICD10:150.9</div>
							</Col>
							<Col xs={24} lg={4} className="text-center">
								<Space>
									<XThemeVASubmitBTN
										size="medium"
										className="radiusBtn me-2"
										shape="square"
										icon={
											<img
												src="/images/edit-icon.svg"
												alt=""
											/>
										}
									/>
									<XThemeVASubmitBTN
										size="medium"
										className="radiusBtn"
										shape="square"
										icon={<PlusSquareOutlined />}
									/>
								</Space>
							</Col>
						</Row>
					</XThemeVSSumListCard>
				</XThemeVSSumInnerCard>
			</>
		),
	},
	{
		key: '3',
		label: 'Past Clinical History',
		children: (
			<>
				<XThemeVSSumListCard className="mb-3">
					<Row gutter={[15, 15]} className="align-items-center">
						<Col xs={24} lg={14}>
							<div className="para1">
								Congestive <span>heart failure</span>
							</div>
						</Col>
						<Col
							xs={24}
							lg={6}
							className="text-center"
							role="button"
							style={{
								borderLeft: '1px solid #57636F26',
								borderRight: '1px solid #57636F26',
							}}
						>
							<div className="para2">ICD10:150.9</div>
						</Col>
						<Col xs={24} lg={4} className="text-center">
							<Space>
								<XThemeVASubmitBTN
									size="medium"
									className="radiusBtn me-2"
									shape="square"
									icon={
										<img
											src="/images/edit-icon.svg"
											alt=""
										/>
									}
								/>
								<XThemeVASubmitBTN
									size="medium"
									className="radiusBtn"
									shape="square"
									icon={<PlusSquareOutlined />}
								/>
							</Space>
						</Col>
					</Row>
				</XThemeVSSumListCard>
				<XThemeVSSumListCard className="mb-3">
					<Row gutter={[15, 15]} className="align-items-center">
						<Col xs={24} lg={14}>
							<div className="para1">
								Congestive <span>heart failure</span>
							</div>
						</Col>
						<Col
							xs={24}
							lg={6}
							className="text-center"
							role="button"
							style={{
								borderLeft: '1px solid #57636F26',
								borderRight: '1px solid #57636F26',
							}}
						>
							<div className="para2">ICD10:150.9</div>
						</Col>
						<Col xs={24} lg={4} className="text-center">
							<Space>
								<XThemeVASubmitBTN
									size="medium"
									className="radiusBtn me-2"
									shape="square"
									icon={
										<img
											src="/images/edit-icon.svg"
											alt=""
										/>
									}
								/>
								<XThemeVASubmitBTN
									size="medium"
									className="radiusBtn"
									shape="square"
									icon={<PlusSquareOutlined />}
								/>
							</Space>
						</Col>
					</Row>
				</XThemeVSSumListCard>
				<Row>
					<Col xs={24} className="text-end">
						<XThemeVASubmitBTN
							size="medium"
							className="radiusBtn"
							shape="square"
							icon={<PlusSquareOutlined />}
						>
							Add Past Clinical History
						</XThemeVASubmitBTN>
					</Col>
				</Row>
			</>
		),
	},
	{
		key: '4',
		label: 'Medicare Coverage',
		children: (
			<>
				<XThemeVSSumListCard>
					<Row gutter={[15, 15]} className="align-items-center">
						<Col xs={24}>
							<div className="para1">
								As per the LCD section L33954, The clinical
								summary indicates that the patient, a
								78-year-old female with bilateral cataracts,
								does not have significant visual impairment. The
								coverage indications require that the patient
								has impairment of visual function due to
								cataracts with decreased ability to carry out
								activities of daily living, a best corrected
								visual acuity of 20/50 or worse, or additional
								testing showing a decrease in visual acuity by
								two lines with consensual light or glare
								testing. Since the patient does not have
								significant visual impairment, these criteria
								are not met.
							</div>
							<div className="para1 fst-italic">
								Reference:{' '}
								<Link
									to="https://www.cms.gov/medicare-coverage-database/view/lcd.aspx?LCDId=33954"
									target="_blank"
									className=" text-decoration-underline"
								>
									Centers for Medicare & Medicaid Services
								</Link>
							</div>
						</Col>
					</Row>
				</XThemeVSSumListCard>
			</>
		),
	},
];
const VACaseDetailsAnalyzed = (props) => {
	const [isExpanded, setIsExpanded] = useState(false);
	return (
		<>
			<XThemeVSSetViewPort>
				<XThemeVSScrollContainer>
					<Row gutter={[15, 15]}>
						<Col xs={24} className="mb-3">
							<XThemeVoiceAssTitle>
								Case has been analysed
								<br />
								<span>and confirmed!</span>
							</XThemeVoiceAssTitle>
						</Col>
						<Col xs={24}>
							<XThemeVoiceAssTableCard>
								<div className="hasPadding">
									<XThemeVSDetailsCard
										// className={`isExpanded ${
										// 	isExpanded ? 'h-100' : 'h-50'
										// }`}
										className={
											isExpanded ? '' : 'isExpanded'
										}
									>
										<Row
											gutter={[15, 15]}
											className="align-items-center"
										>
											<Col xs={2} sm={2} lg={2}>
												<div className="tagsView">
													2<sup>nd</sup>
												</div>
											</Col>
											<Col xs={20} sm={20} lg={20}>
												<Row gutter={[15, 15]}>
													<Col
														xs={24}
														sm={12}
														lg={16}
													>
														<div className="titleHead1">
															Mouse MTST
															<span className="me-4">
																MGB02
															</span>
															<XThemeTag
																style={{
																	background:
																		'#ED982A33',
																	color: '#ED982A',
																}}
															>
																Allocated
															</XThemeTag>
														</div>
														<div className="titleHead2">
															MASB02001
														</div>
													</Col>
												</Row>
											</Col>
											<Col
												xs={2}
												sm={2}
												lg={2}
												className="text-end"
											>
												<XThemeHeaderBTN
													onClick={() =>
														setIsExpanded(
															!isExpanded,
														)
													}
													shape="circle"
													size="large"
													icon={
														isExpanded ? (
															<img
																className="img-fluid"
																src="/images/va-expended-icon.svg"
																alt="Expended"
															/>
														) : (
															<img
																className="img-fluid"
																src="/images/vs-expend-icon.svg"
																alt="Expend"
															/>
														)
													}
												/>
											</Col>
										</Row>

										<Row
											gutter={[15, 10]}
											className="align-items-center mt-3"
										>
											<Col xs={12} sm={12} lg={8}>
												<div className="para1">
													<span>Insurance</span>
													<br />
													Noridian Healthcare
													Solutions, LLC
												</div>
											</Col>
											<Col xs={12} sm={12} lg={8}>
												<div className="para1">
													<span>Hospital</span>
													<br />
													St. Joseph's
												</div>
											</Col>
											<Col xs={12} sm={12} lg={8}>
												<div className="para1">
													<span>State</span>
													<br />
													California - Entire State
												</div>
											</Col>
											<Col xs={12} sm={12} lg={8}>
												<div className="para1">
													<span>DOB</span>
													<br />
													04-05-1965
												</div>
											</Col>
											<Col xs={12} sm={12} lg={8}>
												<div className="para1">
													<span>Gender</span>
													<br />
													Male
												</div>
											</Col>
											<Col xs={12} sm={12} lg={8}>
												<div className="para1">
													<span>Organization</span>
													<br />
													CommonSpirit Health
												</div>
											</Col>
											<Col xs={12} sm={12} lg={8}>
												<div className="para1">
													<span>Revenue Cycle</span>
													<br />
													Pre Service
												</div>
											</Col>
											<Col xs={12} sm={12} lg={8}>
												<div className="para1">
													<span>
														Revenue Cycle Stage
													</span>
													<br />
													Organization Determination
												</div>
											</Col>
											<Col xs={12} sm={12} lg={8}>
												<div className="para1">
													<span>
														Insurance Claim Number
													</span>
													<br />4
												</div>
											</Col>
											<Col xs={12} sm={12} lg={8}>
												<div className="para1">
													<span>
														Providers Encounter
														Number
													</span>
													<br />1
												</div>
											</Col>
											<Col xs={12} sm={12} lg={8}>
												<div className="para1">
													<span>Region</span>
													<br />
													South
												</div>
											</Col>
											<Col xs={12} sm={12} lg={8}>
												<div className="para1">
													<span>Allocated to</span>
													<br />
													Naaz
												</div>
											</Col>
											<Col xs={12} sm={12} lg={8}>
												<div className="para1">
													<span>Claim Amount</span>
													<br />-
												</div>
											</Col>
											<Col xs={12} sm={12} lg={8}>
												<div className="para1">
													<span>Case Amount</span>
													<br />
													$6000
												</div>
											</Col>
											<Col xs={12} sm={12} lg={8}>
												<div className="para1">
													<span>Discharge Date</span>
													<br />
													01-15-2025
												</div>
											</Col>
											<Col xs={12} sm={12} lg={8}>
												<div className="para1">
													<span>Hearing Date</span>
													<br />
													01-02-2025
												</div>
											</Col>
											<Col xs={12} sm={12} lg={8}>
												<div className="para1">
													<span>Admission Date</span>
													<br />
													01-01-2025
												</div>
											</Col>
											<Col xs={12} sm={12} lg={8}>
												<div className="para1">
													<span>EOB Date</span>
													<br />
													01-02-2025
												</div>
											</Col>
											<Col xs={12} sm={12} lg={8}>
												<div className="para1">
													<span>Process Type</span>
													<br />
													MA Standard Appeal
													Turn-Around-Time (TAT)
												</div>
											</Col>
											<Col xs={12} sm={12} lg={8}>
												<div className="para1">
													<span>Visit Type</span>
													<br />
													OP
												</div>
											</Col>
											<Col xs={12} sm={12} lg={8}>
												<div className="para1">
													<span>Status</span>
													<br />
													Allocated
												</div>
											</Col>
											<Col xs={24}>
												<div className="para1">
													<span>Date of Service</span>
													<br />
													01-01-2025, 01-02-2025,
													01-03-2025, 01-14-2025,
													01-17-2025, 02-01-2025 to
													03-31-2025
												</div>
											</Col>
										</Row>
									</XThemeVSDetailsCard>
									<Row>
										<Col xs={24}>
											<XThemeVSCollapse
												bordered={false}
												expandIcon={({ isActive }) => (
													<span
														style={{
															transform: `rotate(${
																isActive
																	? 90
																	: 270
															}deg)`,
															transition:
																'transform 0.3s ease',
														}}
													>
														<img
															class="img-fluid"
															src="/images/chat-back-icon.svg"
															alt=""
														/>
													</span>
												)}
												expandIconPosition="end"
												accordion
												items={items}
											/>
										</Col>
									</Row>
								</div>
								<XThemeVSDetailsFooter>
									<Row gutter={[15, 15]}>
										<Col
											xs={24}
											sm={12}
											lg={12}
											className="text-start"
										>
											<Space>
												<XThemeVASubmitBTN
													size="large"
													className="noBackground"
													icon={
														<img
															class="rotateButton"
															src="/images/like-icon.svg"
															alt=""
														/>
													}
												>
													Refine
												</XThemeVASubmitBTN>
												<XThemeVASubmitBTN
													size="large"
													className="noBackground"
													icon={
														<img
															src="/images/like-icon.svg"
															alt=""
														/>
													}
												>
													Looks Good
												</XThemeVASubmitBTN>
											</Space>
										</Col>
										<Col
											xs={24}
											sm={12}
											lg={12}
											className="text-sm-end"
										>
											<XThemeVASubmitBTN
												className="massages"
												type="text"
												size="large"
												icon={
													<img
														src="/images/analysed-icon.svg"
														alt=""
													/>
												}
											>
												Case has been analysed and
												confirmed!
											</XThemeVASubmitBTN>
										</Col>
									</Row>
								</XThemeVSDetailsFooter>
							</XThemeVoiceAssTableCard>
						</Col>
					</Row>
				</XThemeVSScrollContainer>
			</XThemeVSSetViewPort>
		</>
	);
};

export default VACaseDetailsAnalyzed;
